<template>
  <div id="app">
    <div v-if="$auth.ready() && loaded">
      <router-view></router-view>
    </div>
    <div v-if="!$auth.ready() || !loaded">
      <div style="text-align:center; padding-top:50px;">
        Carregando...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data  () {
    return {
      context: 'app context',
      loaded: false
    }
  },
  created () {
    // console.log('Criou o principal')
    // this.$auth.watch.loaded = false
  },
  mounted () {
    // console.log('Montou o principal')
    var _this = this

    // Set up $auth.ready with other arbitrary loaders (ex: language file).
    setTimeout(function () {
      _this.loaded = true
      var token = _this.$auth.token()

      console.log('Auth principal: ' + token)
    }, 500)
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  // Todo: verificar biblioteca de icones
  // @import 'simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  // Import Main styles for this application
  @import './assets/scss/variaveis.scss';
  @import './assets/scss/style.scss';
  @import "./assets/scss/grid.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue